import React from 'react';

import { Typography } from 'ha/ui/next/Typography';
import * as SearchFilters from 'ha/types/SearchFilters';
import FormGroup from 'ha/ui/next/FormGroup';
import { useIntl } from 'ha/i18n';

import FilterCheckbox from './FilterCheckbox';

interface Props {
  rooms: SearchFilters.RoomsFilterValue;
  onChange: (type: SearchFilters.RoomsValue, selected: boolean) => void;
}

export const RoomsFilter: React.FC<Props> = ({ rooms, onChange }) => {
  const { T } = useIntl();

  return (
    <React.Fragment>
      <Typography.Caption
        textTransform="uppercase"
        color="muted"
        fontWeight="bold"
        data-test-locator="RoomsFilter Title"
      >
        {T('Number of bedrooms')}
      </Typography.Caption>

      <FormGroup row>
        <FilterCheckbox
          name={`${SearchFilters.RoomsValue.ONE}-checkbox`}
          isActive={rooms.bedroomCount.includes(SearchFilters.RoomsValue.ONE)}
          onToggle={(selected: boolean) =>
            onChange(SearchFilters.RoomsValue.ONE, selected)
          }
          data-test-locator="RoomsFilter One"
        >
          <Typography.Paragraph noWrap>1</Typography.Paragraph>
        </FilterCheckbox>
        <FilterCheckbox
          name={`${SearchFilters.RoomsValue.TWO}-checkbox`}
          isActive={rooms.bedroomCount.includes(SearchFilters.RoomsValue.TWO)}
          onToggle={(selected: boolean) =>
            onChange(SearchFilters.RoomsValue.TWO, selected)
          }
          data-test-locator="RoomsFilter Two"
        >
          <Typography.Paragraph noWrap>2</Typography.Paragraph>
        </FilterCheckbox>
        <FilterCheckbox
          name={`${SearchFilters.RoomsValue.THREE}-checkbox`}
          isActive={rooms.bedroomCount.includes(SearchFilters.RoomsValue.THREE)}
          onToggle={(selected: boolean) =>
            onChange(SearchFilters.RoomsValue.THREE, selected)
          }
          data-test-locator="RoomsFilter Three"
        >
          <Typography.Paragraph noWrap>3</Typography.Paragraph>
        </FilterCheckbox>
        <FilterCheckbox
          name={`${SearchFilters.RoomsValue.FOUR_AND_MORE}-checkbox`}
          isActive={rooms.bedroomCount.includes(
            SearchFilters.RoomsValue.FOUR_AND_MORE,
          )}
          onToggle={(selected: boolean) =>
            onChange(SearchFilters.RoomsValue.FOUR_AND_MORE, selected)
          }
          data-test-locator="RoomsFilter FourAndMore"
        >
          <Typography.Paragraph noWrap>4+</Typography.Paragraph>
        </FilterCheckbox>
      </FormGroup>
    </React.Fragment>
  );
};

export default RoomsFilter;
